import { render, staticRenderFns } from "./OcojoImageThumbnail.vue?vue&type=template&id=6a2f8dd6&scoped=true&"
import script from "./OcojoImageThumbnail.vue?vue&type=script&lang=ts&"
export * from "./OcojoImageThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./OcojoImageThumbnail.vue?vue&type=style&index=0&id=6a2f8dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f8dd6",
  null
  
)

export default component.exports